import { Navigate, Route, Routes } from 'react-router-dom';

import { Login } from '../../components/login';
import ChangePassword from '../../components/pages/settings/change-password.component';

interface Props {
  intendedDestination?: string;
}

export function AuthRouter(props: Props) {
  const { intendedDestination } = props;

  return (
    <Routes>
      <Route path='/login' element={<Login />} />
      <Route path='/change-password' element={<ChangePassword />} />
      <Route
        path='*'
        element={
          <Navigate
            to='/login'
            replace
            state={{ 'intended-destination': intendedDestination }}
          />
        }
      />
    </Routes>
  );
}
